<script setup lang="ts">
  const props = defineProps({
    modelValue: {
      type: [String, null],
      required: true
    }
  })
  const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <v-text-field
    color="primary"
    label="Name of GI Database"
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    type="text"
    :clearable="true"
    :persistent-placeholder="true"
    :rules="[(v: string) => !!v || 'Name is required']"
  />
</template>

<style scoped></style>
